import React from "react";
import Cookies from "js-cookie";
import axios from "axios";
import { message } from "antd";

const ReConsolidation = async (RcClient) => {
    const jwtToken = Cookies.get("jwt_token");
    const userLogin = Cookies.get("UserLogin");


    const Data = JSON.stringify(
        {
            Client: RcClient,
            UserName: userLogin
        }
    )

    const url = `${process.env.REACT_APP_BASE_URL}ConsolidationReports/reconsolidate`;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${jwtToken}`,
      },
    };

    try{
        const response = await axios.post(url,Data,config);
        console.log(JSON.parse(response.data));
        if(response.status===200){
            const RequestStatus =JSON.parse(response.data);
            RequestStatus.IsSuccess? message.success(RequestStatus.Message):message.warning("Failed due to : " + RequestStatus.Message);
        }
        
    }
    catch(error){
        message.error("Please Try Again");
    };
}

export default ReConsolidation;